import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const BurgerMenu = ({ className }) => {
  return (
    <svg
      viewBox='0 0 17 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classNames('icon', 'icon-burger-menu', { [className]: className })}
    >
      <rect x='0.0976562' y='9.17969' width='16' height='2' fill='currentColor' />
      <rect x='0.0976562' y='15.1797' width='16' height='2' fill='currentColor' />
      <rect x='0.0976562' y='21.1797' width='16' height='2' fill='currentColor' />
    </svg>
  );
};

BurgerMenu.propTypes = {
  className: PropTypes.string,
};

export default BurgerMenu;
